import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import { bindActionCreators } from 'redux';
import { addFirmDialogValidationSchema } from './admin.constants';
import * as _ from 'lodash';

export const AddFirmDialogFromMenuItem = ({ firms, addFirmToOrganization, setGroup }) => {
  const [open, setOpen] = useState(false);
  const [firm, setFirm] = useState({ firmId: '' });

  const handleSubmit = assigment => {
    addFirmToOrganization(assigment.firmId);
    setFirm({});
    setOpen(false);
  };

  useEffect(() => {
    if (!_.isEmpty(firms)) {
      setFirm({ firmId: firms[0].value });
    }
  }, [firms]);

  const handleClose = formik => {
    formik.resetForm();
    setOpen(false);
  };

  const handleOpen = formik => {
    formik.resetForm();
    setOpen(true);
  };

  return (
    <Formik
      initialValues={firm}
      enableReinitialize
      validationSchema={addFirmDialogValidationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          onClose={() => handleClose(formik)}
          onOpen={() => handleOpen(formik)}
          open={open}
          trigger={<Dropdown.Item icon="building outline" text="Add firm" />}
        >
          <Modal.Header>Assign showcase firm to organization</Modal.Header>
          <Modal.Content>
            <Form widths="equal" onSubmit={formik.handleSubmit}>
              <Form.Field error={Boolean(formik.errors.userGroupId)}>
                <label htmlFor="firmId">Showcase firm</label>
                <Dropdown
                  fluid
                  search
                  selection
                  clearable
                  options={firms || []}
                  id="firmId"
                  data-testid="firmId"
                  label="Firm"
                  name="firmId"
                  value={formik.values.firmId}
                  onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              type="submit"
              content="Assign firm to organization"
              loading={formik.isSubmitting}
              onClick={formik.handleSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  firms: selectors.firms.options(state),
  currentGroup: selectors.getCurrentGroup(state),
});

const mapDispatchToProps = dispatch => ({
  addFirmToOrganization: bindActionCreators(actions.firm.addFirmToOrganization, dispatch),
  getFirms: bindActionCreators(actions.firm.getFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddFirmDialogFromMenuItem);
